var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReferrals(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.8481,
    cy: 17.8481,
    r: 17.8481,
    fill: "url(#paint0_linear_338_349)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0014 19.3851C21.0732 19.3851 23.5634 16.895 23.5634 13.8232C23.5634 10.7514 21.0732 8.26123 18.0014 8.26123C14.9296 8.26123 12.4395 10.7514 12.4395 13.8232C12.4395 16.895 14.9296 19.3851 18.0014 19.3851Z",
    stroke: "white",
    strokeWidth: 1.65943,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0684 17.6998C15.0749 17.1077 16.4654 16.7415 18.0012 16.7415C19.537 16.7415 20.9275 17.1077 21.9341 17.6998",
    stroke: "white",
    strokeWidth: 1.65943,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9995 14.3683C18.9679 14.3683 19.7529 13.5833 19.7529 12.6149C19.7529 11.6465 18.9679 10.8615 17.9995 10.8615C17.0311 10.8615 16.2461 11.6465 16.2461 12.6149C16.2461 13.5833 17.0311 14.3683 17.9995 14.3683Z",
    stroke: "white",
    strokeWidth: 1.65943,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.998 19.381V24.1809",
    stroke: "white",
    strokeWidth: 1.65943,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9995 27.74C18.9679 27.74 19.7529 26.955 19.7529 25.9866C19.7529 25.0182 18.9679 24.2332 17.9995 24.2332C17.0311 24.2332 16.2461 25.0182 16.2461 25.9866C16.2461 26.955 17.0311 27.74 17.9995 27.74Z",
    stroke: "white",
    strokeWidth: 1.65943,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4113 18.443L12.1133 22.6571",
    stroke: "white",
    strokeWidth: 1.65943,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2495 25.9934C12.2179 25.9934 13.0029 25.2084 13.0029 24.24C13.0029 23.2716 12.2179 22.4866 11.2495 22.4866C10.2811 22.4866 9.49609 23.2716 9.49609 24.24C9.49609 25.2084 10.2811 25.9934 11.2495 25.9934Z",
    stroke: "white",
    strokeWidth: 1.65943,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5801 18.4449L23.8781 22.659",
    stroke: "white",
    strokeWidth: 1.65943,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7378 25.9954C25.7062 25.9954 26.4912 25.2103 26.4912 24.2419C26.4912 23.2736 25.7062 22.4885 24.7378 22.4885C23.7694 22.4885 22.9844 23.2736 22.9844 24.2419C22.9844 25.2103 23.7694 25.9954 24.7378 25.9954Z",
    stroke: "white",
    strokeWidth: 1.65943,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_338_349",
    x1: 18.6096,
    y1: 0,
    x2: 18.6096,
    y2: 31.8276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7D14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.998403,
    stopColor: "#F94327"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReferrals);
export default __webpack_public_path__ + "static/media/Referrals.072b2648b77eb1c7131564e75fb4247a.svg";
export { ForwardRef as ReactComponent };